import { render, staticRenderFns } from "./PdpTabBase.vue?vue&type=template&id=5ba16a76&scoped=true"
import script from "./PdpTabBase.vue?vue&type=script&lang=js"
export * from "./PdpTabBase.vue?vue&type=script&lang=js"
import style0 from "./PdpTabBase.vue?vue&type=style&index=0&id=5ba16a76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba16a76",
  null
  
)

export default component.exports